export default __webpack_public_path__ + "static/media/secondary.c22ac9e5fd0fe882d3ef2f822b445d48.svg";